function progressBar(testId, properties) {
    return {
        id: 'progress-bar',
        component: 'magic-ui-step-progress-bar',
        isDataField: false,
        testId: testId,
        properties: properties,
    };
}
function progressBar1of2() {
    return progressBar('step1-progress', {
        'steps': 2,
        'current-step': 1,
    });
}

export { progressBar, progressBar1of2 };
